import { useCallback, useState } from 'react';
import { useRefresh, useEditController, useNotify } from 'react-admin';

export const useQuickEditField = (resource, elementId, editingStates) => {
    const refresh = useRefresh();
    const notify = useNotify();
    const [error, setError] = useState(null);

    const onSuccess = useCallback(() => {
        refresh();
        editingStates.resetAllEditingStates();
    }, [refresh, editingStates]);

    const onError = useCallback(
        error => {
            refresh();
            setError(error);
            notify(error.message || 'ra.notification.http_error', { type: 'error' });
            editingStates.resetAllEditingStates();
        },
        [refresh, editingStates, notify],
    );

    const { save: originalSave, isLoading: isLoadingEdit } = useEditController({
        resource,
        id: elementId,
        mutationMode: 'pessimistic',
        mutationOptions: { onSuccess, onError },
    });

    const save = useCallback(
        formData => {
            setError(null);
            return originalSave(formData);
        },
        [originalSave],
    );

    return { save, isLoadingEdit, error };
};
